import React from 'react'
import ContractCard from './ContractCard'
import MoveOutCTA from './MoveOutCTA'

const ContractPicker: React.FC = () => {
	return (
		<div
			id='contract-picker'
			className='bg-brand-primary-200-light dark:bg-surface-dark drop-shadow-md flex flex-col gap-[0.6rem]'
		>
			<ContractCard />
			<MoveOutCTA />
		</div>
	)
}

export default ContractPicker
